import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import { RenderEditOptions } from "components/MainSectionTemplate/types";
import React, { useState } from "react";
import { RequiredTranslationValueInput, TranslationValueReadonly } from "webform/components/TranslationValueInnerForm";
import { FreeFieldsPanel } from "./freeFieldsPanel/FreeFieldsPanel";

interface FreeFieldCategoryDetailSectionProps {
  freeFieldCategory: server.dto.FreeFieldCategory
  freeFieldDefinitions: server.dto.FreeFieldDefinitionSmall[]
}

interface FreeFieldCategoryState {
  title: server.dto.TranslationValue[]
}

export const FreeFieldCategoryDetailSection = (props: FreeFieldCategoryDetailSectionProps) => {
  const [freeFieldCategory, setFreeFieldCategory] = useState<FreeFieldCategoryState>({
    title: props.freeFieldCategory.title,
  });

  const onValueChanged = (key: string, value: any) => {
    if (key === "title") {
      setFreeFieldCategory({ ...freeFieldCategory, title: value });
    }
  }

  const getUpdateFreeFieldCategoryInstruction = (ffc: FreeFieldCategoryState): server.dto.UpdateFreeFieldCategoryInstruction => ({
    freeFieldCategoryId: props.freeFieldCategory.freeFieldCategoryId,
    title: ffc.title,
  });

  return <DetailSectionTemplate
    isInPageEditable
    onValueChanged={onValueChanged}
    sections={[{
      type: "regular",
      key: "freeFieldCategory",
      title: RESX.FreeField.FreeFieldCategory,
      fields: [{
        key: "title",
        label: RESX.GeneralLabels.Title,
        render: () => <TranslationValueReadonly values={freeFieldCategory.title} />,
        inPageEdit: {
          render: ({ value, onChange, submit, isSaving }: RenderEditOptions<server.dto.TranslationValue[]>) => <RequiredTranslationValueInput
            submit={submit}
            onChange={onChange}
            values={value}
            isSaving={isSaving}
          />,
          fullWidth: true,
          type: "custom",
          initialValue: freeFieldCategory.title,
          submitChange: (title: server.dto.TranslationValue[]) => window.CoreApi.FreeFieldCategory.Update({
            ...getUpdateFreeFieldCategoryInstruction(freeFieldCategory),
            title,
          }),
        }
      }]
    }, {
      type: "custom",
      key: "freeFields",
      render: () => <FreeFieldsPanel
        key="freeFields"
        freeFieldCategoryId={props.freeFieldCategory.freeFieldCategoryId}
        mainArea={props.freeFieldCategory.mainArea}
        freeFieldDefinitions={props.freeFieldDefinitions}
      />
    }]}
  />
}